import React from "react";

/**
 * VehicleDetailZustandIcon
 *
 * Icon for vehicle condition detail. Used in VehicleDetailsList.
 */
const VehicleDetailZustandIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="-0.855 -0.855 24 24"
    fill="none"
    className={className}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2.7797859 6.3908123375 1.6170280499999998 -3.6038657749999996c0.14869287499999997 -0.3969106 0.41513267499999995 -0.738894925 0.7636275375 -0.980147025 0.348485575 -0.2412428125 0.7623830125 -0.3702369 1.1862273625 -0.36967964999999997h8.211766025c0.423788625 -0.0002972 0.83754675 0.12879905 1.1860137499999999 0.37001399999999995 0.34846699999999997 0.24121494999999998 0.614925375 0.5830599624999999 0.763896875 0.979812675l1.6178825 3.6057139874999997"
      strokeWidth="1.71"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.438243675 12.346709625v1.571723625c0 0.36778500000000003 0.14611095 0.72052425 0.4061888125 0.98057425s0.6128264 0.40623525 0.9806299749999999 0.40623525c0.367803575 0 0.7205428249999999 -0.14618525000000002 0.9806206874999999 -0.40623525s0.4061888125 -0.6127892500000001 0.4061888125 -0.98057425V12.53162375"
      strokeWidth="1.71"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.788597624999998 7.678106274999999c-0.24361112499999996 -0.42191255 -0.5940285 -0.7722091875 -1.015959625 -1.015662425 -0.422024 -0.24345323749999997 -0.90070175 -0.37146284999999996 -1.387831125 -0.37115636249999995H3.5166747249999997c-0.7356164375 0 -1.4410949375 0.2922219 -1.9612506625 0.812377625S0.74304550875 8.329308625 0.74304550875 9.064915775v2.080269975c0 0.36778500000000003 0.14611002124999997 0.72052425 0.40618974124999996 0.98057425 0.2600778625 0.26005 0.6128171125 0.40623525 0.9806206874999999 0.40623525h5.547256575"
      strokeWidth="1.71"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.999761999999999 20.8526665c3.063667625 0 5.547238 -2.483570375 5.547238 -5.547238s-2.483570375 -5.547238 -5.547238 -5.547238 -5.547238 2.483570375 -5.547238 5.547238 2.483570375 5.547238 5.547238 5.547238Z"
      strokeWidth="1.71"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m18.472001624999997 13.692282624999999 -2.68575925 3.5816315c-0.0598115 0.07950099999999999 -0.13587612500000001 0.145163625 -0.22308575 0.19262274999999998 -0.08730249999999999 0.047552 -0.183799625 0.075693125 -0.28289725 0.082751625 -0.0991905 0.006965625 -0.198659625 -0.007337125000000001 -0.291720375 -0.042072374999999995 -0.09315362499999999 -0.03473525 -0.177669875 -0.089067125 -0.24797625 -0.159280625l-1.3868095 -1.3868095"
      strokeWidth="1.71"
    />
    <path
      stroke="currentColor"
      d="M3.8652253124999993 9.758283375c-0.1914803875 0 -0.346702375 -0.155194125 -0.346702375 -0.346702375 0 -0.1915175375 0.1552219875 -0.3467488125 0.346702375 -0.3467488125"
      strokeWidth="1.71"
    />
    <path
      stroke="currentColor"
      d="M3.865216025 9.758283375c0.1914803875 0 0.346702375 -0.155194125 0.346702375 -0.346702375 0 -0.1915175375 -0.1552219875 -0.3467488125 -0.346702375 -0.3467488125"
      strokeWidth="1.71"
    />
  </svg>
);

export default VehicleDetailZustandIcon;
